export const md5 = 'e363abe5';
    export const md5Legacy = 'be00ddf5';
    export const md5Dark = '7210cb75';
    export const md5DarkLegacy = '7dae47f7';
    